import React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import {
  core_apimessages_TaxIdentification,
} from '../../schemas/rql';


interface IProps {
  vatId?: core_apimessages_TaxIdentification;
}

export function VatIdSection({
  vatId,
}: IProps) {
  const hasVatId = !!vatId?.taxId;

  return (
    <>
      {hasVatId ? (
        <span id="shop-vat-id">{vatId.taxId} ({vatId.countryCode})</span>
      ) : (
        <Translate text="discovery.internationalTaxProfile.noVatId" />
      )}
      <Translate
        tag="p"
        text={hasVatId ? 'discovery.internationalTaxProfile.hasVatIdPrompt' : 'discovery.internationalTaxProfile.noVatIdPrompt'}
      >
        <CoreLink
          to="/my/selling/tax_policy"
          target="_blank"
        >
          <Translate text="discovery.internationalTaxProfile.vatIdPageLinkText" />
        </CoreLink>
      </Translate>
    </>
  );
}

export default VatIdSection;
